/**
 * React Query hooks for Datasets
 */
import { useQuery } from '@tanstack/react-query';
import { datasetApi } from '@/lib/api/dataset.api';

export function useDatasets() {
  return useQuery({
    queryKey: ['datasets'],
    queryFn: () => datasetApi.list(),
  });
}

// Made with Bob
